import { Form, Input, Select, Button, notification, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { getAllUsers } from '../service/UserDetails';
import axios from 'axios';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
const LIVE_BASE = process.env.REACT_APP_API_LIVE_URL;

const ChangePassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('');
  const [id, setId] = useState();
  const [allUsersName, setAllUsersName] = useState([]);
  const [loading, setLoading] = useState(false);

  const CHANGE_PASSWORD = `${LIVE_BASE}/admin/users/${id}/change-password`;

  const adminChangePassword = (requestBody) => axios.post(CHANGE_PASSWORD, requestBody);

  const handleSubmit = async (values) => {
    if (newPassword !== newPasswordConfirmation) {
      notification.error({ message: 'Passwords do not match!' });
      return;
    }

    const user = { new_password: newPassword, new_password_confirmation: newPasswordConfirmation };
    setLoading(true);
    try {
      const res = await adminChangePassword(user);
      if (res.status === 200) {
        notification.success({ message: 'User Password updated successfully!' });
      } else if (res.status === 401) {
        notification.warning({ message: 'Wrong Credentials!' });
      }
    } catch (error) {
      console.error('Error updating password', error);
      notification.error({ message: 'Authentication failed! '+ error.response.data.message });
    } finally {
      setLoading(false);
    }
  };

  const loadUsersData = async () => {
    try {
      const response = await getAllUsers();
      const dataList = response.data.data;
      const dataListForNames = dataList.map(element => ({
        label: element.attributes.name,
        value: element.id
      }));
      setAllUsersName(dataListForNames);
    } catch (error) {
      console.error('Error loading users data', error);
    }
  };

  useEffect(() => {
    loadUsersData();
  }, []);

  const onChange = (value) => {
    setId(value);
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
      <Form
        name="changePassword"
        {...layout}
        onFinish={handleSubmit}
        style={{ maxWidth: 600, margin: '0 auto', backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}
        scrollToFirstError
      >
        <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Change Password</h1>

        <Form.Item
          name="allAgentNamePicker"
          label="Agent Name"
          rules={[{ required: true, message: 'Please select the agent whose password needs to be changed' }]}
        >
          <Select
            showSearch
            placeholder="Select an agent"
            optionFilterProp="label"
            onChange={onChange}
            options={allUsersName}
          />
        </Form.Item>

        <Form.Item
          name="new_password"
          label="New Password"
          rules={[{ required: true, message: 'Please input your new password' }]}
        >
          <Input.Password
            onChange={e => setNewPassword(e.target.value)}
            placeholder="Enter new password"
          />
        </Form.Item>

        <Form.Item
          name="new_password_confirmation"
          label="Confirm Password"
          rules={[{ required: true, message: 'Please confirm your new password' }]}
        >
          <Input.Password
            onChange={e => setNewPasswordConfirmation(e.target.value)}
            placeholder="Confirm new password"
          />
        </Form.Item>

        <Form.Item style={{ textAlign: 'center' ,marginLeft:'200px'}}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ChangePassword;
